'use strict';
var tripTypeUtils = require('../../modules/utils/trip_type');

module.exports = Odigeo.Model.extend({
    data: {},
    widget: {},
    isEmptyData: false,
    minRowsToDisplay: 2,
    maxRowsToDisplay: 9,
    minPercentageToDisplay: 5,
    sortCriteria: Odigeo.SessionScope.sortCriteria,
    numberOfDaysFlexibility: 2,
    priceFreshnessDays: 5,
    searchStrategy: Odigeo.AB.isFlexibleDatesSearchPrice ? 'SEARCH_PRICE' : 'SEARCH_INDEXER',
    flexibleRoundTripFilterTypes: [
        {filterType: 'a', days: 1, fixed: false},
        {filterType: 'b', days: 1, fixed: 'returnDate', dynamic: 'departureDate'},
        {filterType: 'c', days: 1, fixed: 'departureDate', dynamic: 'returnDate'},
        {filterType: 'd', days: 2, fixed: false},
        {filterType: 'e', days: 2, fixed: 'returnDate', dynamic: 'departureDate'},
        {filterType: 'f', days: 2, fixed: 'departureDate', dynamic: 'returnDate'},
    ],

    defaults: {
        cheapestPrice: 0,
        displayHeader: true,
        displayedList: [],
        searchParameters: {},
        tripType: '',
        usesCount: 0,
        selectedPrice: 0,
        firstSegmentDate: '',
        secondSegmentDate: '',
        interfaceClient: Odigeo.Utils.InterfaceClient.SMARTPHONE,
        isDataValid: true,
        shallValidatePassengers: false,
        isColombia: false,
    },

    init() {
        this.set('shallValidatePassengers', Odigeo._.eq(this.widget.options.shallValidatePassengers, 'true'));
    },

    url: function() {
        return Odigeo.Settings.property('appContext') + '/service/flow/flexibledates';
    },

    getDataRequestSettings: function() {
        return {
            type: 'POST',
            cache: false,
            success: Odigeo._.bind(this.successRequest, this),
            data: this.getRequestParameters(),
            contentType: 'application/json;charset=UTF-8',
            dataType: 'json',
        };
    },

    getRequestParameters: function() {
        var searchParameters = this.get('searchParameters');
        var requestParameters = {
            originGeoNode: Odigeo._.get(searchParameters, 'searchSegments[0].departure.geoNodeId'),
            departureDate: Odigeo._.get(searchParameters, 'searchSegments[0].dateStr'),
            site: Odigeo.SessionScope.website,
            resident: searchParameters.resident,
            adults: searchParameters.numAdults,
            children: searchParameters.numChildren,
            infants: searchParameters.numInfants,
            interfaceClient: this.get('interfaceClient'),
            priceCalculationCriteria: this.sortCriteria,
            numberOfDaysFlexibility: this.numberOfDaysFlexibility,
            priceFreshnessDays: this.priceFreshnessDays,
            searchStrategy: this.searchStrategy,
        };

        if (tripTypeUtils.isRoundTrip(this.get('tripType'))) {
            requestParameters.destinationGeoNode = Odigeo._.get(searchParameters, 'searchSegments[1].departure.geoNodeId');
            requestParameters.returnDate = Odigeo._.get(searchParameters, 'searchSegments[1].dateStr');
        } else if (tripTypeUtils.isOneWay(this.get('tripType'))) {
            requestParameters.destinationGeoNode = Odigeo._.get(searchParameters, 'searchSegments[0].destination.geoNodeId');
        }

        return JSON.stringify(requestParameters);
    },

    successRequest: function(data) {
        if (!this.isResponseDataValid(data)) {
            this.set('isDataValid', false);
            return;
        }

        this.cleanResponseData(data);
        this.set(data);
        Odigeo._.extend(this, data);
    },


    setUpData: function() {
        var searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        this.set('searchParameters', searchParams);
        this.set('cheapestPrice', Odigeo.Session.get('cheapestItineraryPrice'));
        this.set('displayHeader', true);
        this.set('firstSegmentDate', searchParams.searchSegments[0].dateStr);
        this.set('isDataValid', true);

        if (tripTypeUtils.isRoundTrip(this.get('tripType'))) {
            this.set('secondSegmentDate', searchParams.searchSegments[1].dateStr);
        }
    },

    isResponseDataValid: function(data) {
        return !(data.errors && data.errors.length > 0) &&
            data.matrixEntries && data.matrixEntries.length > 0;
    },

    cleanResponseData: function(data) {
        var sortCriteria = this.sortCriteria;

        Odigeo._.forEach(data.matrixEntries, (entry) => {
            entry.apparentPrices = Odigeo._.find(entry.apparentPrices, function(price) {
                return price.apparentPriceCriteria === sortCriteria;
            }).apparentPrice;

            entry.apparentPrices.amount = this.calculatePriceByPax(entry.apparentPrices.amount);
        });

        return data;
    },

    calculatePriceByPax(price) {
        const {numAdults, numChildren, numInfants} = this.get('searchParameters');
        const shallValidatePax = this.get('shallValidatePassengers');
        const paxsNumber = numAdults + numChildren + numInfants;

        return shallValidatePax ? (price / paxsNumber) : price;
    },

    getDifferentDatesRoundTrip: function(filter) {
        var model = this;
        var dateList = [];

        var comparativeList = Odigeo._.filter(this.matrixEntries, function(entry) {
            if (!filter.fixed) {
                return model.selectSameNumberOfDays(entry, filter);
            } else {
                return model.selectFixingOneDay(entry, filter);
            }
        });

        if (comparativeList.length > 0) {
            dateList = dateList.concat(comparativeList);
        }

        Odigeo._.forEach(dateList, Odigeo._.bind(function(date) {
            date['price'] = date.apparentPrices.amount;
            date['flexibleType'] = filter.filterType;
            date['cheapest'] = false;
            date['searched'] = this.isSearchedRoundTrip(date.departureDate, date.returnDate);
        }, this));

        return dateList;
    },
    isSearchedRoundTrip: function(departureDate, returnDate) {
        var searchParameters = this.get('searchParameters');

        return (departureDate === Odigeo._.get(searchParameters, 'searchSegments[0].dateStr') &&
        returnDate === Odigeo._.get(searchParameters, 'searchSegments[1].dateStr'));
    },
    selectSameNumberOfDays: function(entry, filter) {
        var searchDepartureDate = Odigeo.Utils.parseDate(this.get('firstSegmentDate')).getTime();
        var searchReturnDate = Odigeo.Utils.parseDate(this.get('secondSegmentDate')).getTime();
        var departureDate = Odigeo.Utils.parseDate(entry.departureDate).getTime();
        var returnDate = Odigeo.Utils.parseDate(entry.returnDate).getTime();
        var comparedDepartureMore = Odigeo.Utils.addDays(searchDepartureDate, filter.days);
        var comparedReturnMore = Odigeo.Utils.addDays(searchReturnDate, filter.days);
        var comparedDepartureLess = Odigeo.Utils.addDays(searchDepartureDate, filter.days * -1);
        var comparedReturnLess = Odigeo.Utils.addDays(searchReturnDate, filter.days * -1);

        return (departureDate === comparedDepartureMore && returnDate === comparedReturnMore) ||
            (departureDate === comparedDepartureLess && returnDate === comparedReturnLess);
    },

    selectFixingOneDay: function(entry, filter) {
        var searchDepartureDate = Odigeo.Utils.parseDate(this.get('firstSegmentDate')).getTime();
        var searchReturnDate = Odigeo.Utils.parseDate(this.get('secondSegmentDate')).getTime();
        var fixedDay = Odigeo.Utils.parseDate(entry[filter.fixed]).getTime();
        var dynamic = Odigeo.Utils.parseDate(entry[filter.dynamic]).getTime();
        var moreDays = Odigeo.Utils.addDays(dynamic, filter.days);
        var lessDays = Odigeo.Utils.addDays(dynamic, filter.days * -1);
        var comparableFixedDay = filter.fixed === 'returnDate' ? searchReturnDate : searchDepartureDate;
        var comparableDynamicDay = filter.fixed === 'returnDate' ? searchDepartureDate : searchReturnDate;

        return fixedDay === comparableFixedDay &&
            (comparableDynamicDay === moreDays || comparableDynamicDay === lessDays);
    },

    getRoundTripContentParams: function(rowData, index) {
        const suffix = ' 00:00:00';
        const destFormat = this.widget.options.extendedDayDateFormat;
        const collapsedDateFormat = this.widget.options.dateFormat;
        const from = Odigeo.Utils.formatDate(rowData.departureDate, destFormat);
        const to = Odigeo.Utils.formatDate(rowData.returnDate, destFormat);
        const price = Odigeo.Utils.splitFormatedCurrency(rowData.apparentPrices.amount);

        const currencyFormat = Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 0});
        const roundedPrice = Math.ceil(rowData.apparentPrices.amount);
        return {
            dates: {
                departure: Odigeo.Utils.formatDate(rowData.departureDate + suffix, collapsedDateFormat),
                departureShortDay: Odigeo.Utils.formatDate(rowData.departureDate + suffix, 'ddd'),
                return: Odigeo.Utils.formatDate(rowData.returnDate + suffix, collapsedDateFormat),
                returnShortDay: Odigeo.Utils.formatDate(rowData.returnDate + suffix, 'ddd'),
            },
            times: from + ' - ' + to,
            price: price.integer,
            priceFormatted: Odigeo.Utils.formatCurrency(roundedPrice, currencyFormat),
            flexibleType: rowData.flexibleType,
            departureDate: rowData.departureDate,
            returnDate: rowData.returnDate,
            index: index,
            cheaper: rowData.cheaper,
            cheapest: rowData.cheapest,
            searched: rowData.searched,
        };
    },

    updateSearchObject: function(departureDate, returnDate) {
        var searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        searchParameters.buyPath = 'CALENDAR_SEARCH_FLEXIBLE_DATES';
        searchParameters.searchSegments[0].dateStr = departureDate;
        if (returnDate) {
            searchParameters.searchSegments[1].dateStr = returnDate;
        }

        Odigeo.Session.set('searchParameters', JSON.stringify(searchParameters));
    },

    processOneWayData: function() {
        var days = [];
        this.optimizeMatrixEntriesForOneWayProcessing();
        for (var i = -this.numberOfDaysFlexibility; i <= this.numberOfDaysFlexibility; i++) {
            days.push(this.createOneWayDataForDayFromMatrix(i));
        }
        this.set('displayedList', days);
    },

    createOneWayDataForDayFromMatrix: function(dayOffset) {
        const dayData = {
            date: null,
            priceFormatted: null,
            cheapest: false,
            searched: dayOffset === 0,
            cheaper: false,
            offset: dayOffset,
        };
        const currencyFormat = Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 0});
        const dateFormat = this.widget.options.dateFormat;
        const extendedDateFormat = this.widget.options.extendedDayDateFormatSplited;
        const suffix = 'T00:00:00';
        const stringFormat = Odigeo.Utils.formatDate.masks.isoDateTime;
        if (this.matrixEntriesByDayOffset[dayOffset]) {
            const roundedPrice = Math.ceil(this.matrixEntriesByDayOffset[dayOffset].apparentPrices.amount);
            dayData.date = Odigeo.Utils.parseDate(this.matrixEntriesByDayOffset[dayOffset].departureDate + suffix, stringFormat);
            dayData.priceFormatted = Odigeo.Utils.formatCurrency(roundedPrice, currencyFormat);
            dayData.price = this.matrixEntriesByDayOffset[dayOffset].apparentPrices.amount;
            dayData.cheapest = this.matrixEntriesByDayOffset[dayOffset].cheapest;
            dayData.cheaper = this.matrixEntriesByDayOffset[dayOffset].cheaper;
            dayData.cheaperDay = this.matrixEntriesByDayOffset[dayOffset].cheaper;
        } else {
            dayData.date = Odigeo.Utils.parseDate(this.get('firstSegmentDate') + suffix, stringFormat);
            dayData.date.setDate(dayData.date.getDate() + dayOffset);
        }
        if (dayOffset === 0) {
            const roundedPrice = Math.ceil(this.get('cheapestPrice'));
            dayData.price = this.get('cheapestPrice');
            dayData.priceFormatted = Odigeo.Utils.formatCurrency(roundedPrice, currencyFormat);
        }
        dayData.dates = {
            departure: Odigeo.Utils.formatDate(dayData.date, dateFormat),
            departureShortDay: Odigeo.Utils.formatDate(dayData.date, 'ddd'),
        };
        dayData.date = Odigeo.Utils.formatDate(dayData.date, extendedDateFormat);
        return dayData;
    },

    optimizeMatrixEntriesForOneWayProcessing: function() {
        this.optimizeMatrixEntriesForOneWayProcessingFromMatrix();
    },

    optimizeMatrixEntriesForOneWayProcessingFromMatrix: function() {
        var indexedByDayOffset = {
            '0': {
                departureDate: this.get('firstSegmentDate'),
                apparentPrices: {
                    amount: this.get('cheapestPrice'),
                },
            },
        };
        var numberOfDaysFlexibility = this.numberOfDaysFlexibility;
        var todaysPrice = this.get('cheapestPrice');
        var cheapestPrice = todaysPrice;
        var cheapestIndex = 0;
        Odigeo._.each(this.matrixEntries, function(entry) {
            indexedByDayOffset[entry.matrixColumn - numberOfDaysFlexibility] = entry;
            if (entry.matrixColumn === numberOfDaysFlexibility) {
                entry.apparentPrices.amount = todaysPrice;
            }
            if (entry.apparentPrices.amount < cheapestPrice) {
                cheapestIndex = entry.matrixColumn - numberOfDaysFlexibility;
                cheapestPrice = entry.apparentPrices.amount;
            }
            if (entry.apparentPrices.amount < todaysPrice) {
                entry.cheaper = true;
            }
            entry.price = entry.apparentPrices.amount;
        });
        if (cheapestIndex !== 0) {
            indexedByDayOffset[cheapestIndex].cheapest = true;
        }
        this.matrixEntriesByDayOffset = indexedByDayOffset;
    },
    shouldOneWayBeRenderedOnResults: function() {
        return this.isFlexibleDatesScope() && this.widget.options.page === 'results';
    },

    isFlexibleDatesScope() {
        return !Odigeo.Utils.isRequestApp('dp') && Odigeo.SessionScope.flow === 'mobile';
    },

    shouldOneWayBeRendered: function() {
        return (!(this.widget.options.isColombia === 'true'))
            || (this.numberOfDaysWithPrice() > 1 &&
            this.shouldOneWayBeRenderedOnResults() &&
            tripTypeUtils.isOneWay(this.get('tripType')));
    },
    shouldRoundTripBeRendered: function() {
        return this.isFlexibleDatesScope() && tripTypeUtils.isRoundTrip(this.get('tripType'));
    },

    numberOfDaysWithPrice: function() {
        var currentDate = this.get('firstSegmentDate');
        return Odigeo._.filter(this.matrixEntries, function(matrixEntry) {
            return matrixEntry.departureDate !== currentDate;
        }).length;
    },

    getOneWayEntryWithOffset: function(offset) {
        return this.matrixEntriesByDayOffset[offset];
    },
    cleanData: function() {
        this.unset('matrixEntries');
        this.unset('displayedList');
    },
    processRoundTripData: function() {
        var dates = [];

        Odigeo._.each(this.flexibleRoundTripFilterTypes, Odigeo._.bind(function(filterType) {
            var deltaLength = this.maxRowsToDisplay - dates.length;
            dates = dates.concat(this.getDifferentDatesRoundTrip(filterType, deltaLength));
            if (dates.length === this.maxRowsToDisplay) {
                return false;
            }
        }, this));

        if (dates.length < this.minRowsToDisplay) {
            return false;
        }

        dates = this.sortByFlexibleType(dates);
        dates = this.setCheaperDays(dates);
        dates = this.setCheapestDay(dates);

        this.set('displayedList', this.getRoundTripDataRows(dates));
    },
    sortByFlexibleType: function(dates) {
        return Odigeo._.sortBy(dates, 'flexibleType');
    },
    setCheaperDays: function(dates) {
        var cheapestFlightPrice = this.get('cheapestPrice');
        return Odigeo._.map(dates, function(date) {
            date['cheaper'] = Odigeo._.gt(cheapestFlightPrice, date.apparentPrices.amount);
            return date;
        });
    },
    setCheapestDay: function(dates) {
        Odigeo._.min(dates, Odigeo._.property('apparentPrices.amount'))['cheapest'] = true;
        return dates;
    },
    getRoundTripDataRows: function(rowsData) {
        return Odigeo._.map(rowsData, this.getRoundTripContentParams.bind(this));
    },
    createCurrentDayItem: function() {
        var searchParameters = this.get('searchParameters');
        return {
            departureDate: Odigeo._.get(searchParameters, 'searchSegments[0].dateStr'),
            returnDate: Odigeo._.get(searchParameters, 'searchSegments[1].dateStr'),
            apparentPrices: {
                amount: this.get('cheapestPrice'),
            },
            cheapest: false,
            searched: true,
        };
    },
    getPriceSavings: function(items) {
        var cheapestPrice = this.get('cheapestPrice');
        var difference = cheapestPrice - Odigeo._.min(Odigeo._.filter(items, {'searched': false}), Odigeo._.property('price')).price;
        return Math.floor((difference / cheapestPrice)* 100);
    },
    getNumOptionsForTracking: function() {
        if (tripTypeUtils.isOneWay(this.get('tripType'))) {
            return this.numberOfDaysWithPrice();
        } else {
            return Odigeo._.get(this.get('displayedList'), 'length', 0);
        }
    },
    getItemFromIndex: function(index) {
        return this.get('displayedList')[index];
    },
    getTrackingPriceDifference: function() {
        var selectedPrice = this.get('selectedPrice');
        var cheapestPrice = this.get('cheapestPrice');
        var differenceInPercentage = Math.round(100 * (1 - selectedPrice / cheapestPrice));

        return this.getNumberForTracking(differenceInPercentage, 2);
    },
    getNumberForTracking: function(number, digits) {
        var topValue = Number(Odigeo._.padLeft('', digits, 9));
        var sign = number >= 0 ? '+' : '-';
        var abs = Odigeo._.round(Math.abs(number));
        abs = abs > topValue ? topValue : abs;

        return sign + Odigeo._.padLeft(abs, digits, 0);
    },
    getCheapestDisplayDay: function() {
        return Odigeo._.min( this.get('displayedList'), Odigeo._.property('price')).price;
    },
    getExpensiveDisplayDay: function() {
        return Odigeo._.max( this.get('displayedList'), Odigeo._.property('price')).price;
    },
    updateSelectedData: function(selectedDayItem) {
        this.updateSearchObject(selectedDayItem.departureDate, selectedDayItem.returnDate);
        this.set('selectedPrice', selectedDayItem.price);
        this.set('usesCount', this.get('usesCount') + 1);
    },
});
